import { Card } from 'apps/shared/scripts/__generated__/graphql.generated';
import { LabelValue } from 'apps/shared/scripts/components';
import { formatDateYear } from 'apps/shared/scripts/utils';

import { widgetStatsClassName } from './styles';

type Props = Pick<Card, 'createdAt' | 'postCount'>;

const WidgetStats = ({ createdAt, postCount }: Props) => {
  return (
    <div className={widgetStatsClassName}>
      <LabelValue label="Posts" value={postCount} />
      <LabelValue label="Created on" value={formatDateYear(createdAt)} />
    </div>
  );
};

WidgetStats.displayName = 'WidgetStats';

export default WidgetStats;
